import Axios from "axios"


export async function notice_load(props) {
    const Set_noticeList = props['Set_noticeList']
    const isMounted = props['isMounted']

    const branch_id = window.EventManager['branchInfo']['id']
    const result = await Axios
                    .post("/notice/load", {
                        branch_id: branch_id
                    })
    Set_noticeList(result['data']['list'])

    if(isMounted) {
        isMounted.current++
    }
}